import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

export default function MissionCallout() {
  return (
    <section data-testid="mission-callout" className="py-14 md:py-20" style={{ background: "var(--surface-2)", borderTop: "1px solid var(--border)", borderBottom: "1px solid var(--border)" }}>
      <div className="max-w-[1400px] mx-auto px-6 md:px-12 grid md:grid-cols-12 gap-8 items-center">
        <div className="md:col-span-3">
          <div className="eyebrow">About SunPress</div>
          <div className="mt-3 h-1 w-14 rounded-full sunset-bg" aria-hidden="true" />
        </div>
        <blockquote className="md:col-span-7 font-serif text-xl sm:text-2xl md:text-[1.75rem] leading-snug" style={{ color: "var(--ink)" }} data-testid="mission-statement">
          At SunPress Solar, we believe reliable everyday living shouldn't require massive power grids or
          fuel-guzzling setups. We engineer <span className="sunset-text">energy-smart appliances</span> designed to work
          efficiently with the power you actually have.
        </blockquote>
        <div className="md:col-span-2 md:text-right">
          <Link to="/about" data-testid="mission-about-link" className="inline-flex items-center gap-2 text-sm font-medium sunset-text py-2">
            Our story <ArrowRight size={14} color="var(--sun-orange)" />
          </Link>
        </div>
      </div>
    </section>
  );
}
